import _createForOfIteratorHelperLoose from "@babel/runtime/helpers/esm/createForOfIteratorHelperLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _class, _class2, _temp;

import React from 'react';
import invariant from 'invariant';
import { getRandomID, isNonNullable } from "../../../lib/utils";
import { Radio } from "../../Radio";
import { createPropsGetter } from "../../../lib/createPropsGetter";
import { FocusTrap } from "../../../internal/FocusTrap";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { rootNode } from "../../../lib/rootNode";
import { getVisualStateDataAttributes } from "../../../internal/CommonWrapper/utils/getVisualStateDataAttributes";
import { styles } from "../RadioGroup.styles";
import { Prevent } from "../Prevent";
import { RadioGroupContext } from "../RadioGroupContext";
export var RadioGroupDataTids = {
  root: 'RadioGroup__root'
};
export
/**
*
* `children` может содержать любую разметку с компонентами Radio,
* если не передан параметр `items`.
* Каждому компоненту Radio нужно указать параметр `value`, такого же типа
* как и параметр `value` самой радиогруппы.
*
* Значения активного элемента сравниваются по строгому равенству `===`
*/
var RadioGroup = rootNode(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(RadioGroup, _React$Component);

  function RadioGroup(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.name = getRandomID();
    _this.getProps = createPropsGetter(RadioGroup.defaultProps);

    _this.getRadioGroupContextValue = function () {
      return {
        activeItem: _this.getValue(),
        onSelect: _this.handleSelect,
        name: _this.getName(),
        disabled: _this.props.disabled,
        error: _this.props.error,
        warning: _this.props.warning
      };
    };

    _this.getValue = function () {
      return _this.isControlled() ? _this.props.value : _this.state.activeItem;
    };

    _this.getName = function () {
      return _this.props.name || _this.name;
    };

    _this.isControlled = function () {
      return isNonNullable(_this.props.value);
    };

    _this.handleSelect = function (value) {
      if (!_this.isControlled()) {
        _this.setState({
          activeItem: value
        });
      }

      if (_this.props.onValueChange) {
        _this.props.onValueChange(value);
      }
    };

    _this.renderRadio = function (itemValue, data, index) {
      var _cx;

      var itemProps = {
        key: _this.getKeyByItem(itemValue),
        className: cx((_cx = {}, _cx[styles.item(_this.theme)] = true, _cx[styles.itemFirst()] = index === 0, _cx[styles.itemInline()] = !!_this.props.inline, _cx))
      };
      return /*#__PURE__*/React.createElement("span", _extends({}, itemProps, {
        role: "presentation"
      }), /*#__PURE__*/React.createElement(Radio, {
        value: itemValue
      }, _this.getProps().renderItem(itemValue, data)));
    };

    _this.getKeyByItem = function (itemValue) {
      if (_this.props.toKey) {
        return _this.props.toKey(itemValue);
      }

      return typeof itemValue === 'string' || typeof itemValue === 'number' ? itemValue : undefined;
    };

    _this.ref = function (element) {
      _this.node = element;
    };

    _this.state = {
      activeItem: _this.props.defaultValue
    };
    return _this;
  }

  var _proto = RadioGroup.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return _this2.renderMain();
    });
  };

  _proto.renderMain = function renderMain() {
    var _this$props = this.props,
        width = _this$props.width,
        onMouseLeave = _this$props.onMouseLeave,
        onMouseOver = _this$props.onMouseOver,
        onMouseEnter = _this$props.onMouseEnter,
        onBlur = _this$props.onBlur,
        ariaDescribedby = _this$props['aria-describedby'],
        disabled = _this$props.disabled;
    var style = {
      width: width != null ? width : 'auto'
    };
    var handlers = {
      onMouseOver: onMouseOver,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    };
    return /*#__PURE__*/React.createElement(CommonWrapper, _extends({
      rootNodeRef: this.setRootNode
    }, this.props, getVisualStateDataAttributes({
      disabled: disabled
    })), /*#__PURE__*/React.createElement(FocusTrap, {
      onBlur: onBlur
    }, /*#__PURE__*/React.createElement("span", _extends({
      "data-tid": RadioGroupDataTids.root,
      ref: this.ref,
      style: style,
      className: styles.root(),
      role: "radiogroup"
    }, handlers, {
      "aria-describedby": ariaDescribedby
    }), /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
      value: this.getRadioGroupContextValue()
    }, this.renderChildren()))));
  }
  /**
  * @public
  */
  ;

  _proto.focus = function focus() {
    var node = this.node;

    if (!node) {
      return;
    }

    var radio = node.querySelector('input[type="radio"]:checked'); // If no checked radios, try get first radio

    if (!radio || radio.disabled) {
      radio = node.querySelector('input[type="radio"]:not([disabled])');
    }

    if (radio) {
      radio.focus();
    }
  };

  _proto.renderChildren = function renderChildren() {
    var _this$props2 = this.props,
        items = _this$props2.items,
        children = _this$props2.children;
    invariant(!items && children || items && !children, 'Either items or children must be passed, not both');
    return items ? mapItems(this.renderRadio, items) : children;
  };

  return RadioGroup;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'RadioGroup', _class2.displayName = 'RadioGroup', _class2.defaultProps = {
  renderItem: renderItem
}, _class2.Prevent = Prevent, _temp)) || _class;

function renderItem(_value, data) {
  return data;
}

function mapItems(fn, items) {
  var result = [];
  var index = 0;

  for (var _iterator = _createForOfIteratorHelperLoose(items), _step; !(_step = _iterator()).done;) {
    var entry = _step.value;

    var _normalizeEntry = normalizeEntry(entry),
        _value2 = _normalizeEntry[0],
        _data = _normalizeEntry[1];

    result.push(fn(_value2, _data, index));
    ++index;
  }

  return result;
}

function normalizeEntry(entry) {
  if (!Array.isArray(entry)) {
    return [entry, entry];
  }

  return entry;
}